import type { ReactNode } from 'react'
import { AktivierungAufgaben } from './bodies/AktivierungAufgaben'
import { AufgabeFormular } from './bodies/AufgabeFormular'
import { PersonOverview } from './bodies/PersonOverview'
import { useApp } from '@/core/state/appStore'
import { ErstgespraechCheckliste } from '@/variants/azav/components/modal/bodies/ErstgespraechCheckliste'
import { AvgsUpload } from '@/variants/azav/components/modal/bodies/AvgsUpload'
import { AvgsStammdaten } from '@/variants/azav/components/modal/bodies/AvgsStammdaten'
import { AvgsDokument } from '@/variants/azav/components/modal/bodies/AvgsDokument'
import { TbHochladen } from '@/variants/azav/components/modal/bodies/TbHochladen'
import { TbDokument } from '@/variants/azav/components/modal/bodies/TbDokument'
import { BewilligungHochladen } from '@/variants/azav/components/modal/bodies/BewilligungHochladen'
import { BewilligungDokument } from '@/variants/azav/components/modal/bodies/BewilligungDokument'
import { VertragDokument } from '@/variants/azav/components/modal/bodies/VertragDokument'
import { PersonalDetails } from './bodies/PersonalDetails'
import { PersonalDokumente } from './bodies/PersonalDokumente'
import { InviteCoachModal } from '@/core/components/orgsettings/InviteCoachModal'
import { MemberDetails } from '@/core/components/orgsettings/MemberDetails'
import { CreateMassnahmeModal } from '@/core/components/orgsettings/CreateMassnahmeModal'
import { MassnahmeDetails } from '@/core/components/orgsettings/MassnahmeDetails'
import { ModulDetails } from '@/variants/azav/components/orgsettings/ModulDetails'
import { CreateModulModal } from '@/variants/azav/components/orgsettings/CreateModulModal'
import { EcnNachweis } from '@/variants/azav/components/modal/bodies/EcnNachweis'
import { AbschlussberichtDokument } from '@/variants/azav/components/modal/bodies/AbschlussberichtDokument'
import { AnwesenheitslisteDokument } from '@/variants/azav/components/modal/bodies/AnwesenheitslisteDokument'
import { ZertifikatDokument } from '@/variants/azav/components/modal/bodies/ZertifikatDokument'
import { AnwesenheitPersonTab } from '@/variants/vergabe/components/anwesenheit/AnwesenheitPersonTab'
import { VerbisLebenslauf } from '@/variants/vergabe/components/verbis-lebenslauf/VerbisLebenslauf'
import { AufnahmePotenzialanalyse } from '@/variants/vergabe/components/aufnahme-potenzialanalyse/AufnahmePotenzialanalyse'
import { KompetenzfeststellungBox } from '@/variants/vergabe/components/kompetenzfeststellung/KompetenzfeststellungBox'
import { TeilnehmendePersonAnlegen } from '@/variants/vergabe/components/teilnehmende-anlegen/TeilnehmendePersonAnlegen'
import { GespeichertesDokument } from './bodies/GespeichertesDokument'
import { DokumentHochladen } from './bodies/DokumentHochladen'

export function PhaseContent({ actions }: { actions?: ReactNode }) {
  const { state } = useApp()
  const screen = state.screen
  if (!screen || screen.tab === null) return null
  const { kind: modal, tab, coachingId } = screen

  if (modal === 'invite-coach') return <InviteCoachModal />
  if (modal === 'member') return <MemberDetails actions={actions} userId={screen.memberId} />

  if (modal === 'create-massnahme') return <CreateMassnahmeModal />
  if (modal === 'massnahme') return <MassnahmeDetails actions={actions} massnahmeId={screen.massnahmeId} />

  if (modal === 'modul') {
    return <ModulDetails actions={actions} massnahmeId={screen.massnahmeId} modulId={screen.modulId} />
  }

  if (modal === 'create-modul') return <CreateModulModal />
  if (modal === 'ecn') return <EcnNachweis coachingId={coachingId} />

  if (modal === 'erstgespraech') {
    return <ErstgespraechCheckliste coachingId={coachingId} />
  }
  if (modal === 'avgs') {

    if (tab === 'stammdaten') return <AvgsStammdaten coachingId={coachingId} />
    if (tab === 'avgs') return <AvgsDokument coachingId={coachingId} />
    if (tab === 'tb-hochladen') return <TbHochladen coachingId={coachingId} />
    if (tab === 'bestaetigung') return <TbDokument coachingId={coachingId} />
    return <AvgsUpload coachingId={coachingId} />
  }
  if (modal === 'bewilligung') {
    if (tab === 'bewilligung') return <BewilligungDokument coachingId={coachingId} />
    return <BewilligungHochladen coachingId={coachingId} />
  }
  if (modal === 'vertrag') {
    return <VertragDokument coachingId={coachingId} />
  }

  if (modal === 'abschluss') {

    if (tab === 'teilnehmendenliste') return <AnwesenheitslisteDokument coachingId={coachingId} />

    if (tab === 'zertifikat') return <ZertifikatDokument coachingId={coachingId} />
    return <AbschlussberichtDokument coachingId={coachingId} />
  }
  if (modal === 'personal') {
    if (tab === 'uebersicht') return <PersonOverview actions={actions} coachingId={coachingId} />
    if (tab === 'aktivierung' && coachingId) return <AktivierungAufgaben coachingId={coachingId} />
    if (tab === 'dokumente') return <PersonalDokumente coachingId={coachingId} />
    if (tab === 'termine') return <PersonOverview coachingId={coachingId} coachingOnly />
    if (tab === 'anwesenheit' && coachingId) return <AnwesenheitPersonTab coachingId={coachingId} />
    return <PersonalDetails coachingId={coachingId} />
  }

  if (modal === 'verbis-lebenslauf') return <VerbisLebenslauf coachingId={coachingId} />

  if (modal === 'kompetenzfeststellung' || modal === 'kompetenzbilanzierung') return <KompetenzfeststellungBox coachingId={coachingId} />

  if (modal === 'aufnahme-potenzialanalyse') return <AufnahmePotenzialanalyse coachingId={coachingId} />

  if (modal === 'teilnehmende-person-anlegen') return <TeilnehmendePersonAnlegen />
  if (modal === 'dokument') return <GespeichertesDokument coachingId={coachingId} />
  if (modal === 'dokument-hochladen') return <DokumentHochladen coachingId={coachingId} />
  if (modal === 'aufgabe') return <AufgabeFormular />
  return null
}
